import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { IApplicationState } from '../stateManagement/states/applicationState';
import { IAuthenticationDataState } from 'app/stateManagement/states/dataState';
import * as fromRoot from '../stateManagement/rootReducer';


@Injectable()
export class AuthStateGuard implements CanActivate {

  constructor(
    private router: Router, 
    private store: Store<IApplicationState>
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.guard();
  }

  private guard(): Observable<boolean> | boolean {
    return this.store.select(fromRoot.getAuthenticationDataState)
      .map((authState: IAuthenticationDataState) => {
        if ((authState.isAuthenticated && !authState.isMFAEnabled) || (authState.isAuthenticated && authState.isMFAEnabled && authState.isMFAAuthenticated)) {
            return true;
        }
        else {
            this.router.navigate(['/authentication']);
            return false;
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/authState.guard.ts